import Topbar from "../components/shared/Topbar";
import TabNav from "../components/shared/TabNav";
import Sidebar from "../components/shared/Sidebar";
import { useSessionKeepalive } from "../hooks/useSessionKeepalive";

export default function AdminLayout({ variant, children }) {
  // Ping cada 25 min para detectar expiración del JWT antes de que el
  // usuario haga una acción y se le caiga el form.
  useSessionKeepalive();
  return (
    <div className="min-h-screen flex flex-col">
      <Topbar />
      {variant === "superadmin" ? (
        <div className="flex flex-1">
          <Sidebar />
          <main className="flex-1 p-6 bg-bg-main">{children}</main>
        </div>
      ) : (
        <>
          <TabNav />
          <main className="flex-1 p-6 bg-bg-main">{children}</main>
        </>
      )}
    </div>
  );
}
